import React, { useState } from 'react';

const SignInContext = React.createContext({
    isVerified: false,
    setIsVerified: () => { },
    onSuccessfulVerification: () => { },
    trackVerificationClick: () => { },
    locale: "",
    customerId: "",
    localizedHelpCopy: undefined
});
const useSignInContext = () => {
    const context = React.useContext(SignInContext);
    return context;
};
const SignInContextProvider = ({ onSuccessfulVerification, locale, customerId, localizedHelpCopy, trackVerificationClick, children }) => {
    const [isVerified, setIsVerified] = useState(false);
    return (React.createElement(SignInContext.Provider, { value: {
            isVerified,
            setIsVerified,
            onSuccessfulVerification,
            trackVerificationClick,
            locale,
            customerId,
            localizedHelpCopy
        } }, children));
};

export { SignInContextProvider, useSignInContext };
//# sourceMappingURL=SignInContext.js.map
